import {
    CUSTOMERBASE_KO,
    INVOICING_OK,
    INVOICING_REQUESTED,
    INVOICING_REQUESTED_DO_NOT_SEND,
    TOBE_SENT
} from "../../../component/Constants";
import {useTranslation} from "react-i18next";
import {useAmazonInvoiceStatusValuesVoucher} from "../../../component/useAmazonInvoiceStatusValuesVoucher";

export const useVoucherAmazonInvoiceStatuses = () => {
    const { getAmazonInvoiceStatusColorVoucher, getAmazonInvoiceStatusLabelVoucher } = useAmazonInvoiceStatusValuesVoucher();
    const {t} = useTranslation(['salesmarketing'], {keyPrefix: 'voucher'});
    const amazonInvoiceStatuses = [
        {
            value: TOBE_SENT,
            label: getAmazonInvoiceStatusLabelVoucher(TOBE_SENT),
            color: getAmazonInvoiceStatusColorVoucher(TOBE_SENT)
        },
        {
            value: CUSTOMERBASE_KO,
            label: getAmazonInvoiceStatusLabelVoucher(CUSTOMERBASE_KO),
            color: getAmazonInvoiceStatusColorVoucher(CUSTOMERBASE_KO)
        },
        {
            value: INVOICING_REQUESTED,
            label: getAmazonInvoiceStatusLabelVoucher(INVOICING_REQUESTED),
            color: getAmazonInvoiceStatusColorVoucher(INVOICING_REQUESTED)
        },
        {
            value: INVOICING_OK,
            label: getAmazonInvoiceStatusLabelVoucher(INVOICING_OK),
            color: getAmazonInvoiceStatusColorVoucher(INVOICING_OK)
        },
        {
            value: INVOICING_REQUESTED_DO_NOT_SEND,
            label: getAmazonInvoiceStatusLabelVoucher(INVOICING_REQUESTED_DO_NOT_SEND),
            color: getAmazonInvoiceStatusColorVoucher(INVOICING_REQUESTED_DO_NOT_SEND)
        },
    ];


    return {amazonInvoiceStatuses}
}